import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { CommonModule } from '@angular/common';
import { SidebarService } from './services/sidebar.service';
import { SseService } from './services/sse.service';
import { SidemenuComponent } from './components/sidemenu/sidemenu.component';
import { ToastModule } from 'primeng/toast';
import { HeaderComponent } from './shared/header/header.component';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MenuItem } from 'primeng/api';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ButtonModule,
    RippleModule, CommonModule, SidemenuComponent, ToastModule, HeaderComponent, BreadcrumbModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
 
  items: MenuItem[] | undefined;
  title = 'kavach';
  isSidemenuOpen = true;
  isloggedIn: any = false;

  constructor(private sidebarService: SidebarService,
    public router: Router,
    private sseService: SseService) {
    this.sidebarService.sidebarState$.subscribe(state => {
      this.isSidemenuOpen = state;
    });
  }


  ngOnInit() {
    for (let item of ['userInfo', 'csrfToken', 'userPermissions', 'customerInfo']) {
      localStorage.removeItem(item);
    }
    this.sseService.generateConnectionId(); // Generate new UUID on app load
    this.items = [
      { label: 'Home' },
    ];
    this.subscribeRouterEvents()
  }

  subscribeRouterEvents() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isloggedIn = localStorage.getItem("loggedIn")
      }
    })
  }
}